import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

import {Sensor} from '../sensor/sensor';
import {Alarma} from '../alarmas/alarma';
import {Sucursal} from '../sucursal/sucursal';

import {AlarmaService} from './alarma.service';
import {PermisoService} from '../permiso/permiso.service';

declare var $: any;
import * as _ from "lodash";

@Component({
    selector: 'abmalarmas',
    template: require('../../app/abmalarmas/abmalarmas.component.html'),
    styles: [require('../../app/abmalarmas/abmalarmas.component.css')]
})
export class AbmAlarmasComponent implements OnInit {

    @Input() alarma: Alarma;
    @Input() sensor: Sensor;
    @Input() sucursal: Sucursal;

    active: any;
    deshabilitar: boolean;
    @Output() permisos = new EventEmitter();

    constructor(private alarmaService: AlarmaService,
                private permisoService: PermisoService) {
    }

    ngOnInit() {
        this.alarma = new Alarma();
        this.sensor = new Sensor();
        this.active = true;

        //Pedir permisos
        this.permisoService.getPermiso("alarma").subscribe(permisos => {
            var respuesta = new Map();
            for (let permiso of permisos.tipoPermiso) {
                respuesta.set(permiso.descripcion, true);
            }
            this.permisos.emit({permisos: respuesta});
        })
    }


    closeModal() {
        //Reseteo formEmpresa para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Inicializo variables
        if (this.alarma._id != undefined && this.alarma._id != "" && this.alarma._id != null)
            this.alarmaService.getAlarma(this.alarma._id).subscribe((alarma) => {
                for (let alarmaL of this.sensor.alarmas) {
                    if (alarmaL._id == alarma._id) {
                        alarmaL.descripcion = alarma.descripcion;
                        alarmaL.valorMaximo = alarma.valorMaximo;
                        alarmaL.valorMinimo = alarma.valorMinimo;
                        break;
                    }
                }
            });
        //Seteo bandera para deshabilitar
        this.deshabilitar = false;
        //Ocultar modal
        $("#modalAlarma").modal("hide");
        $("#confirmacionAlarma").modal("hide");
    }

    eliminar() {
        //Busco alarma
        this.alarmaService
            .getAlarma(this.alarma._id)
            .subscribe(alarma => {
                this.alarmaService.delete(alarma).subscribe(
                    (alarma) => {
                        for (let alarmaL of this.sensor.alarmas) {
                            if (alarmaL._id == alarma._id) {
                                alarmaL.estado = alarma.estado;
                                if (!alarma.estado) {
                                    for (let aviso of alarmaL.avisosLista) {
                                        aviso.estado = alarma.estado;
                                    }
                                }
                                break;
                            }
                        }
                    }
                );
                $("#confirmacionAlarma").modal("hide");
            });
    }

    save() {
        //Determino operacion
        var operacion = "";
        console.log(this.alarma, this.sensor);
        if (this.alarma._id == "" || this.alarma._id == undefined)
            operacion = "agregar";
        else
            operacion = "modificar";
        //Elimino redundancia
        this.alarma.sensor_id = this.sensor._id;
        var alarmaSimplificado = _.cloneDeep(this.alarma);

        //Armar los avisos lista
        if (this.alarma.avisosLista != undefined) {
            var idsAvisosLista = [];
            this.alarma.avisosLista.forEach(function (aviso) {
                idsAvisosLista.push(aviso._id);
            });
            //delete alarmaSimplificado.avisosLista;
            alarmaSimplificado.avisosLista = idsAvisosLista;
        }
        alarmaSimplificado.sucursal_id = this.sucursal._id;

        //Guardo
        this.alarmaService
            .save(alarmaSimplificado)
            .subscribe((alarma) => {
                //Inicializo variables
                this.alarma = alarma;
                //Actualizo listas
                if (operacion == "agregar") {
                    if (this.sensor.alarmas == undefined)
                        this.sensor.alarmas = [];
                    this.sensor.alarmas.push(alarma);
                }
                else
                    for (let alarmaL of this.sensor.alarmas) {
                        if (alarmaL._id == alarma._id) {
                            alarmaL.descripcion = alarma.descripcion;
                            alarmaL.valorMaximo = alarma.valorMaximo;
                            alarmaL.valorMinimo = alarma.valorMinimo;
                            break;
                        }
                    }
                //Ocultar modal
                $("#modalAlarma").modal("hide");
                //Reseteo formEmpresa para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
            })
    }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/abmalarmas/abmalarmas.component.ts